import { render, staticRenderFns } from "./UserDetailPermissionTable.vue?vue&type=template&id=a484666e&scoped=true&"
import script from "./UserDetailPermissionTable.vue?vue&type=script&lang=js&"
export * from "./UserDetailPermissionTable.vue?vue&type=script&lang=js&"
import style0 from "./UserDetailPermissionTable.vue?vue&type=style&index=0&id=a484666e&lang=scss&scoped=true&"
import style1 from "./UserDetailPermissionTable.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a484666e",
  null
  
)

export default component.exports